import { useMemo } from 'react';
import { GroupBase } from 'react-select';
import { Right } from 'fp-ts/lib/Either';
import { format, parseISO } from 'date-fns';

export type ResourceApi = Right<CF.API.Datasets.ListDatasetVersionsResponse>;

export type VersionDataEntity = CF.API.Datasets.DatasetVersion[] | CF.API.Models.ModelVersion[] | CF.API.Workflows.WorkflowVersion[];

export type ResourceType = 'datasets' | 'models' | 'workflows' | 'modules';

export interface OptionVersionValue {
  date: string;
  description?: string;
  label: string;
  value: string;
  link?: string;
}

export interface GroupVersionValue extends GroupBase<OptionVersionValue> {
  label: string;
  options: OptionVersionValue[];
}

type UsePlatformResourceVersionSelectorProps = {
  type: ResourceType;
  data: VersionDataEntity;
  loading: boolean;
  selected?: string;
};

export const usePlatformResourceVersionSelector = ({ type, loading, data, selected }: UsePlatformResourceVersionSelectorProps) => {
  const options: OptionVersionValue[] = useMemo(
    () =>
      data.map((version) => {
        return {
          date: version.created_at ? format(parseISO(version.created_at), 'MMM dd, yyyy - HH:mm') : '',
          description: 'description' in version ? version.description : '',
          label: version.id,
          value: version.id,
        };
      }),
    [data],
  );

  const selectedOption = useMemo(
    () =>
      options.find((version) => {
        return version.value === selected;
      }),
    [options, data, selected],
  );

  return {
    type,
    options,
    loading,
    selected: loading ? undefined : selectedOption,
  };
};
